import React, {useState} from 'react';
import {HashRouter, Routes, Route} from 'react-router-dom';
import Home from './views/home';
import About from './views/about';
import {Header} from "@/components/header";
import Training from "./views/training";
import WirtualnyAsystent from "./views/wirtualnyAsystent";
import ProgramAfiliacyjny from "./views/programAfiliacyjny";
import Login from "./views/login";
import Register from "./views/register";
import Footer from "@/components/footer";
import Paths from "./constants/Paths";
import AffiliateProgramRegulations from "./views/affiliateProgramRegulations";
import PrivacyPolicy from "./views/privacyPolicy";
import ScrollToTop from "./ScrollToTop";
import TermsOfService from "./views/termsOfService";
import ServiceProvisionRegulations from "./views/serviceProvisionRegulations";
import ReturnPolicy from "./views/returnPolicy";
import Support from "./views/support/support";
import SupportVideo from "./views/support/supportVideo";
import SupportAi from "./views/support/supportAi";
import SupportOnline from "./views/support/supportOnline";
import SupportDiscord from "./views/support/supportDiscord";
import Pricing from "./views/pricing";
import TrainingFundamentalAnalysis from "./views/trainingFundamentalAnalysis";
import TrainingTechnicalAnalysis from "./views/trainingTechnicalAnalysis";
import TrainingLongPosition from "./views/trainingLongPosition";
import TrainingShortPosition from "./views/trainingShortPosition";
import Contact from "./views/contact";
import CookieConsentCustom from "@/components/cookieConsentCustom";
import { Toaster } from "react-hot-toast";
import GTMPageTracker from "./GTMPageTracker";

const App = () => {
    const [isDiscount, setIsDiscount] = useState(true);

    return (
        <>
            <HashRouter>
                <GTMPageTracker />
                <Toaster position="bottom-center" toastOptions={{ duration: 5000 }} />
                <CookieConsentCustom />
                <ScrollToTop />
                <Header isDiscount={isDiscount} setIsDiscount={setIsDiscount} />
                <main className={`bg-transparent ${isDiscount ? 'main-discount-enabled' : ''}`}>
                    <Routes>
                        <Route exact path={Paths.HOME} element={<Home/>}/>
                        <Route path={Paths.ABOUT} element={<About/>}/>
                        <Route path={Paths.TRAINING} element={<Training/>}/>
                        <Route path={Paths.TRAINING_FUNDAMENTAL_ANALYSIS} element={<TrainingFundamentalAnalysis/>}/>
                        <Route path={Paths.TRAINING_TECHNICAL_ANALYSIS} element={<TrainingTechnicalAnalysis/>}/>
                        <Route path={Paths.TRAINING_LONG_POSITION} element={<TrainingLongPosition/>}/>
                        <Route path={Paths.TRAINING_SHORT_POSITION} element={<TrainingShortPosition/>}/>
                        <Route path={Paths.VIRTUAL_ASSISTANT} element={<WirtualnyAsystent/>}/>
                        <Route path={Paths.AFFILIATE_PROGRAM} element={<ProgramAfiliacyjny/>}/>
                        <Route path={Paths.LOGIN} element={<Login/>}/>
                        <Route path={Paths.REGISTER} element={<Register/>}/>
                        <Route path={Paths.AFFILIATE_PROGRAM_REGULATIONS} element={<AffiliateProgramRegulations/>}/>
                        <Route path={Paths.PRIVACY_POLICY} element={<PrivacyPolicy/>}/>
                        <Route path={Paths.TERMS_OF_SERVICE} element={<TermsOfService/>}/>
                        <Route path={Paths.SERVICE_PROVISION_REGULATIONS} element={<ServiceProvisionRegulations/>}/>
                        <Route path={Paths.RETURN_POLICY} element={<ReturnPolicy/>}/>
                        <Route path={Paths.SUPPORT} element={<Support/>}/>
                        <Route path={Paths.SUPPORT_VIDEO} element={<SupportVideo/>}/>
                        <Route path={Paths.SUPPORT_AI} element={<SupportAi/>}/>
                        <Route path={Paths.SUPPORT_ONLINE} element={<SupportOnline/>}/>
                        <Route path={Paths.SUPPORT_DISCORD} element={<SupportDiscord/>}/>
                        <Route path={Paths.PRICING} element={<Pricing/>}/>
                        <Route path={Paths.CONTACT} element={<Contact/>}/>
                        <Route path="*" element={<Home/>}/>
                    </Routes>
                </main>
                <Footer/>
            </HashRouter>
        </>
    );
};

export default App;
